import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { IonIcon, IonSelect, IonSelectOption } from "@ionic/vue";
import { ref, watch } from "vue";
import { route } from "@/router";
import i18n, { changeLanguage } from "@/plugins/vue-i18n";
import { Capacitor } from "@capacitor/core";

import { toFlagHexCode } from "@/functions/converter";

import { APP_LANGUAGES } from "@/types/enum/ionicEnum";
import { LanguageDropdownProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageDropdown',
  props: {
    changeFunction: {},
    colors: { default: 'coral-light-color' },
    language: {}
  },
  setup(__props: any) {

const props = __props

const selectEl = ref()

function openSelect() {
    selectEl.value.$el.click()
}

const language = ref<APP_LANGUAGES>(
    route.value.query.lang ?
        route.value.query.lang :
        (
            //Not supported
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            i18n.global.locale.value ?? Object.values(APP_LANGUAGES)[0]
        )
)

watch(props, () => { if (props.language) language.value = props.language })

const selectChangeFunction = (): void => {
    if (props.changeFunction) {
        props.changeFunction(language.value)
    } else {
        changeLanguage(language.value)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "language-container",
    onClick: openSelect
  }, [
    _createVNode(_unref(IonIcon), {
      src: "assets/icon/globe.svg",
      class: _normalizeClass([__props.colors, "language-dropdown-icon"])
    }, null, 8, ["class"]),
    _createVNode(_unref(IonSelect), {
      ref_key: "selectEl",
      ref: selectEl,
      "cancel-text": _ctx.$t('button.cancel'),
      interface: "action-sheet",
      modelValue: language.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
      onIonChange: selectChangeFunction,
      class: _normalizeClass(["language-dropdown", __props.colors]),
      "selected-text": language.value.toString().toUpperCase(),
      mode: "ios"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APP_LANGUAGES), (lang) => {
          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
            key: lang,
            value: lang
          }, {
            default: _withCtx(() => [
              (_unref(Capacitor).isNativePlatform())
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    innerHTML: _unref(toFlagHexCode)(lang)
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(lang.toString().toUpperCase()), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["cancel-text", "modelValue", "class", "selected-text"])
  ]))
}
}

})